/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_DescriptionInputs */



/**
* | output |
* | --- |
* | "We're sorry, but something unexpected happened. Our team has been notified and is working on a fix." |
*
* @param {Error_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const error_description = /** @type {((inputs?: Error_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Entschuldigung, aber es ist etwas Unerwartetes passiert. Unser Team wurde benachrichtigt und arbeitet an einer Lösung.")
	return /** @type {LocalizedString} */ ("We're sorry, but something unexpected happened. Our team has been notified and is working on a fix.")
});